import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import { loadScript } from 'utils/loadScript';
import Loading from 'components/Loading/Loading';
import { connect } from 'react-redux';
import { makePayment } from 'actions/stripePaymentActions';
import { updateUpsellData } from 'actions/userActions';
import { Link } from 'react-router';
import { UPSELL_PRICE } from 'config/constants';
import './style.css';

const joiningBenefits = [
  "Learn how you can acquire 1,000's of new vocabulary",
  'Proven methods to become a fluent and confident speaker in your target language',
  'How to have natural and flowing conversations (even as a beginner)',
  'Memorization techniques to remember 90% more information than you do today',
  'Understand 85% of common speech in 100 days',
  '& much more'
];

class Offer47 extends Component {
  componentDidMount() {
    fbq('track', 'Purchase'); // eslint-disable-line

    loadScript('https://fast.wistia.com/embed/medias/aunig3j44a.jsonp');
    loadScript('https://fast.wistia.com/assets/external/E-v1.js');

    window.scrollTo(0, 0);
  }

  handleActivate = () => {
    const stripeCustomerId = get(this.props.user, 'profile.stripeCustomerId');

    if (stripeCustomerId) {
      this.props.makePayment(
        {
          amount: UPSELL_PRICE,
          stripeCustomerId
        },
        () => this.updateUpsellData('UPSELL_2', true)
      );
    }
  }

  handleSkip = (event) => {
    event.preventDefault();
    this.updateUpsellData('UPSELL_2', false);
  }

  updateUpsellData = (status, paid) => {
    this.props.updateUpsellData({
      ...this.props.user.upsellData,
      status,
      paid
    });
  }

  render() {
    const { payment } = this.props;

    return (
      <div className="offer-47 mx-auto my-5 p-4 px-sm-5 pt-sm-5">
        <div className="px-0 px-sm-4">
          <div className="offer-47__header">
            <h6 className="offer-47__header-title mb-3">
              Last chance to get faster results ($150 free gift)
            </h6>
            <p>
              Take advantage of our exclusive offer to get $150 off our most popular language
              hacking masterclass (normally $197). This offer is only available today exclusively
              for new members.
            </p>
          </div>

          <div className="offer-47__subheader text-center pt-2">
            <span className="offer-47__subheader-origin">$197</span>
            &nbsp;&nbsp;
            <span className="offer-47__subheader-sale">$47</span>
          </div>

          <div className="offer-47__video">
            <div className="wistia_responsive_padding mt-4 mb-5">
              <div className="wistia_responsive_wrapper">
                <div className="wistia_embed wistia_async_aunig3j44a videoFoam=true">&nbsp;</div>
              </div>
            </div>
          </div>

          <h6 className="offer-47__title mb-3">What I&#39;ll learn by joining</h6>
          <ul>
            {joiningBenefits.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <div className="offer-47__price my-4">
            <p className="m-0">
              Regular price: <span className="offer-47__price-origin">$197</span>
            </p>
            <p className="m-0">
              You only pay: <span className="offer-47__price-sale">$47</span> ($150 off)
            </p>
          </div>

          <div className="offer-47__action">
            <p className="m-0">
              This offer is only available here and now. You cannot claim this offer later or
              anywhere else on our site. Our most successful members take this option.{' '}
              <strong>We have a 30-day money back guarantee.</strong>
            </p>

            {payment.paymentStatus === 'LOADING' ? (
              <div className="text-center mt-4">
                <Loading size="small" />
              </div>
            ) : (
              <Fragment>
                <button
                  type="button"
                  className="btn btn-primary btn-lg btn-green btn-cursor w-100 my-4 px-2 py-sm-4"
                  onClick={this.handleActivate}
                >
                  Yes! I want to get faster results!
                </button>
                <div className="text-center">
                  <Link className="custom-link" to="#" onClick={this.handleSkip}>
                    No thanks, I don’t want this one-time special offer
                  </Link>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    payment: state.stripePayment
  };
}

export default connect(
  mapStateToProps,
  {
    makePayment,
    updateUpsellData
  }
)(Offer47);



// WEBPACK FOOTER //
// ./src/pages/student/Offer47/index.js